import { render } from "./presentershero.vue?vue&type=template&id=96be04ce&scoped=true"
import script from "./presentershero.vue?vue&type=script&lang=js"
export * from "./presentershero.vue?vue&type=script&lang=js"

import "./presentershero.vue?vue&type=style&index=0&id=96be04ce&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-96be04ce"

export default script